module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAs0lEQVRIx2N4ziBMI8QwavTgMvqNlef39Vv/Pn0OREAGkEsdoz9VNP3//fvb7EXvI1KACMgAcoGClBoNdCDQoHde4c9ZJT4k5v46efbX6fNf+qcDBQm6nYDRQO8DnQlkAM39////p5K6/3///r519+fBo0ApiowGBi4wEIAMoHu/r9n0glv2Bbvkj/Vb/9y9D5SiotGbXwKN5pCijtFYA+QPVQKEhtFIw8RH2ywzWjwNAaMBO1WwAnOphK4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/tn.png
// module id = 942
// module chunks = 0